import type { ReactElement } from 'react'
import { observer } from 'mobx-react-lite'
import { TemplatePickerBase } from 'app/components/templates/TemplatePickerBase'
import { renderSample } from 'app/lib/messageTemplates'
import type { TaskTemplate } from 'app/generated/graphql'
import { useTaskTemplateStore } from 'app/stores/StoreContext'
import { useWorkspace } from 'app/utils'
import { bg } from 'lib/background'

type TaskTemplatePickerProps = {
  trigger: ReactElement
  onSelect: (template: TaskTemplate) => void
  /** Forwarded to the popover, "top" for triggers at a modal's bottom edge. */
  side?: `top` | `bottom`
}

/** Task binding of the shared template picker. Previews show the sample-
 *  rendered title; apply policy stays with the surface (applyTaskTemplate). */
export const TaskTemplatePicker = observer(function TaskTemplatePicker({
  trigger,
  onSelect,
  side,
}: TaskTemplatePickerProps) {
  const store = useTaskTemplateStore()
  const workspace = useWorkspace()
  const templates = store.forWorkspace(workspace?.id)
  const items = templates.map((t) => ({ id: t.id, name: t.name, preview: renderSample(t.title), searchText: t.title }))

  return (
    <TemplatePickerBase
      trigger={trigger}
      items={items}
      onOpen={() => bg(store.load())}
      onSelectId={(id) => {
        const template = templates.find((t) => t.id === id)
        if (template) onSelect(template)
      }}
      manageHref="/settings/templates/tasks"
      emptyLabel="No task templates yet."
      side={side}
    />
  )
})
